.container {
  margin-bottom: 1rem;
}

.content {
  margin: 0;
  white-space: pre-wrap;
}

.meta {
  align-items: center;
  display: flex;
  font-family: var(--font-family-base);
  gap: 0.5rem;
  justify-content: flex-end;
  margin: 0.5rem 0 0;
  text-align: right;
}

.aiImage {
  height: 75px;
  width: 75px;
}
